import { useField } from 'formik';
import { CSSProperties, FocusEventHandler } from 'react';
import { Form, Icon, Label, Popup } from 'semantic-ui-react';

interface Props {
    placeholder: string;
    name: string;
    type?: string;
    label?: string;
    required?: boolean | false;
    disabled?: boolean | false;
    readOnly?: boolean | false;
    onFocus?: FocusEventHandler;
    onBlur?: FocusEventHandler;
    style?: CSSProperties;
    infomessage?: string;
    disabledvalue?:string;
    maxLength?:number;
    tooltip?:string;
}

export default function MyTextInput(props: Props) {
    const [field, meta] = useField(props.name); 
    return (
        <Form.Field error={meta.touched && !!meta.error} required={props.required}  >
            <label>{props.label}
                 {props.tooltip && 
                    <Popup content={props.tooltip} position='top center' inverted trigger={<Icon size='large' name='question circle outline'/>}></Popup> 
                 }                 
            </label>
            {!props.disabled && <input  {...field} {...props} />}            
            {props.disabled &&  
                <Label color='green' size='large'>{props.disabledvalue}</Label>
            }
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ) : null}           
        {props.infomessage && props.infomessage !== '' && (
            <Label color='blue'> <Icon name='info' />{props.infomessage}</Label>
        )}  
        </Form.Field>   
           
    )
}